import React from 'react';

export const Footer = () => {
  return <footer className="Footer">Coded with &hearts; by Stephanie Zeng</footer>;
}



// WEBPACK FOOTER //
// ./src/components/Footer.js